import Divider from '@portalterreno/react-ui-core/Divider';
import { Col, Row } from '@portalterreno/react-ui-core/Grid';
import Typography from '@portalterreno/react-ui-core/Typography';
import LanguageIcon from '@portalterreno/react-ui-icons/LanguageIcon';
import { useTranslation } from 'next-i18next';
import React from 'react';

import { about, help, myAccount, socialMedia } from '../footerLinks';
import StyledTypography from '../StyledTypography';
import StyledBottom from './StyledBottom';
import StyledFooter from './StyledFooter';
import StyledLink from './StyledLink';
import VerticalDividerWrapper from './VerticalDivierWrapper';

export type FooterProps = Omit<
  React.HTMLAttributes<HTMLDivElement>,
  'children'
>;

const FooterDesktop: React.FC<FooterProps> = (props) => {
  const { t } = useTranslation('common');
  return (
    <StyledFooter {...props}>
      <Row>
        <Col lg={2}>
          <Typography
            color='white'
            variant='body1'
          >
            {t('about')}
          </Typography>
          <ul>
            {about.map(({ url, text }) => (
              <li key={`${url}-${t(text)}`}>
                <StyledLink href={url}>{t(text)}</StyledLink>
              </li>
            ))}
          </ul>
        </Col>
        <Col lg={2}>
          <Typography
            color='white'
            variant='body1'
          >
            {t('help')}
          </Typography>
          <ul>
            {help.map(({ url, text }) => (
              <li key={`${url}-${t(text)}`}>
                <StyledLink href={url}>{t(text)}</StyledLink>
              </li>
            ))}
          </ul>
        </Col>
        <Col lg={5}>
          <Typography
            color='white'
            variant='body1'
          >
            {t('myAccount')}
          </Typography>
          <ul>
            {myAccount.map(({ url, text }) => (
              <li key={`${url}-${t(text)}`}>
                <StyledLink href={url}>{t(text)}</StyledLink>
              </li>
            ))}
          </ul>
        </Col>
        <Col lg={1}>
          <VerticalDividerWrapper>
            <Divider orientation='vertical' />
          </VerticalDividerWrapper>
        </Col>
        <Col lg={2}>
          <Typography
            color='white'
            variant='body1'
          >
            {t('followUs')}
          </Typography>
          <ul>
            {socialMedia.map(({ url, text }) => (
              <li key={`${url}-${text}`}>
                <StyledLink
                  href={t(`social:${url}`).toString()}
                  target='_blank'
                  rel='noreferrer'
                >
                  {text}
                </StyledLink>
              </li>
            ))}
          </ul>
        </Col>
      </Row>
      <Row>
        <Col>
          <StyledBottom>
            <StyledTypography
              color='white'
              variant='text'
            >
              {t('copyright')}
            </StyledTypography>
            <div>
              <LanguageIcon />
              <StyledTypography
                color='white'
                variant='text'
              >
                {t('footerCountry')}
              </StyledTypography>
            </div>
          </StyledBottom>
        </Col>
      </Row>
    </StyledFooter>
  );
};
export default FooterDesktop;
